import { Icon } from '@sas/nova-commons/components/Icon';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { GrabberResizer } from '@sas/react-svg';
import React, { useEffect, useRef } from 'react';
import { useResizable } from './hooks/useResizable';
import { useLatestRef } from '../hooks';
import { MoveFocusInside } from 'react-focus-lock';
import cx from 'classnames';
import cn from './Panel.css.json';
import './Panel.css';
export function Panel(props) {
    var _a;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : { width: 350, height: 400 };
    const dt = useDesignTokens();
    const panelTokens = getPanelTokens(dt);
    const panelRef = useRef(null);
    const { startResize, onArrowKeyResize, abortResize } = useResizable({
        ref: panelRef,
        onResize: (newSize) => {
            if (newSize) {
                props.onSizeChange(newSize);
            }
        },
    });
    const onSizeChangeRef = useLatestRef(props.onSizeChange);
    useEffect(() => {
        var _a, _b;
        if ((props.maxHeight !== undefined && props.maxHeight < size.height) ||
            (props.maxWidth !== undefined && props.maxWidth < size.width)) {
            onSizeChangeRef.current({
                height: Math.min(size.height, (_a = props.maxHeight) !== null && _a !== void 0 ? _a : size.height),
                width: Math.min(size.width, (_b = props.maxWidth) !== null && _b !== void 0 ? _b : size.width),
            });
        }
    }, [size.height, size.width, props.maxHeight, props.maxWidth, onSizeChangeRef]);
    return (React.createElement("div", { ref: panelRef, className: cx(cn.container, props.className), style: Object.assign(Object.assign({ height: size.height, width: size.width, maxHeight: props.maxHeight, maxWidth: props.maxWidth, minHeight: props.minHeight, minWidth: props.minWidth }, renderInlineCssVars(panelTokens, 'panel')), props.style), tabIndex: -1 },
        React.createElement(MoveFocusInside, { className: cn.containerInner, key: props.contentKey, disabled: !props.autofocus }, props.children),
        React.createElement("div", { className: cn.resizeGrabber, tabIndex: 0, onMouseDown: startResize, onMouseUp: abortResize, onKeyDown: onArrowKeyResize },
            React.createElement(Icon, { icon: GrabberResizer }))));
}
function getPanelTokens(dt) {
    return dt.reportTokens.backgroundsDepth.standard;
}
